// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["./style-contact-info-section","./style-additional-sections-frontend"], () => (__webpack_require__("./block/assets/js/additional-sections/frontend.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
